import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { tabs } from '../../projects/tabs/infrastructure-projects-tab.component';
import { useUser } from '../../../contexts/user.context';
import classes from './styles.module.scss';
import { getInfrastructureProjects } from '../../../requests/public-infrastructure';
import { InfrastructureProjectType } from '../../../types/project.types';
import { ChevronRightIcon, PlusIcon } from '../../../assets/icons';
import { createInfrastructureProject } from '../../../requests/supervisor.request';
import { getLang } from '../../../helpers/utils';

const baseClass = 'infrastructure-projects-tab';
const additionalClass = 'screening-tab';
const translationKey = 'projects.infrastructure-projects';

const InfrastructureProjectsTab = () => {
  const { t } = useTranslation();
  const { kato, tab } = useParams<{ tab: string; kato: string }>();
  const { isModulePresent, modules } = useUser();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [filteredTabs, setFilteredTabs] = useState(
    tabs.filter((tab) => isModulePresent(tab.key))
  );
  const [selectedTab, setSelectedTab] = useState<{
    key: InfrastructureProjectType;
    label: string;
  } | null>(null);
  const [list, setList] = useState<any[]>([]);

  const onTabChange = (type: { key: InfrastructureProjectType; label: string }) => {
    if (kato) {
      navigate(`/admin/${kato}/infrastructure-projects/${type.key}`, { replace: true });
      setSelectedTab(type);
    }
  };

  const handleAddObject = () => {
    if (!selectedTab || !kato) return;
    createInfrastructureProject(Number(kato), selectedTab.key).then((res) => {
      const id = res.id
      navigate(`/admin/${kato}/infrastructure-projects/${selectedTab.key}/${id}`);
    });
  };

  const editObject = (id: number) => {
    if (!kato || !selectedTab) return;
    navigate(`/admin/${kato}/infrastructure-projects/${selectedTab.key}/${id}`);
  };

  useEffect(() => {
    const filtered = tabs.filter((tab) => isModulePresent(tab.key));
    setFilteredTabs(filtered);

    if (!filtered.length || !kato) return;

    const matchedTab = filtered.find((t) => t.key === tab);
    if (matchedTab) {
      setSelectedTab(matchedTab);
    } else {
      const fallbackTab = filtered[0];
      setSelectedTab(fallbackTab);
      navigate(`/admin/${kato}/infrastructure-projects/${fallbackTab.key}`, { replace: true });
    }
  }, [modules, tab, kato]);

  useEffect(() => {
    if (!kato || !selectedTab) return;
    setLoading(true);

    getInfrastructureProjects(kato, selectedTab.key).then((data) => {
      setList(data);
    })
      .finally(() => setLoading(false));
  }, [selectedTab, kato]);

  if (!tab || !selectedTab) return null;

  return (
    <div className={classes[baseClass]}>
      <div className={classes[`${additionalClass}__tabs`]}>
        {filteredTabs.map((tab) => (
          <div
            key={tab.key}
            className={
              selectedTab?.key === tab.key
                ? `${classes[`${additionalClass}__tab`]} ${classes[`${additionalClass}__tab--active`]}`
                : classes[`${additionalClass}__tab`]
            }
            onClick={() => onTabChange(tab)}
          >
            {t(tab.label)}
          </div>
        ))}
      </div>

      <div className={classes[`${baseClass}__list`]}>
        {!loading && list.map((item, index) => (
          <div key={index} className={classes[`${baseClass}__item`]} onClick={() => editObject(item.id)}>
            <span>{tab === InfrastructureProjectType.INTERNET_COMMUNICATION ? item.communicationProvider?.name : item[`name${getLang()}`] || t(`${translationKey}.name`)}</span>
            <ChevronRightIcon />
          </div>
        ))}
      </div>

      {!(['VILLAGE_ROAD', 'LIGHTING'].includes(tab) && list.length > 0) && <button className={classes[`${baseClass}__btn`]} onClick={handleAddObject}>
        <PlusIcon /> {t('actions.add')}
      </button>}
    </div>
  );
};

export default InfrastructureProjectsTab;
